import { LoggedUser } from '../../interfaces'
import { AnalyticsEvent, LOGIN } from '../events'

export interface LoginProperties {
  // only credentials login exists today; the property documents it and gives
  // future SSO flows something to differ from
  login_method: string
  // the credentials were accepted but the user must still change the password
  // before being let into the app
  requires_password_change: boolean
}

/**
 * Builds the `login` event for a successful sign-in. Tenant, role and user id
 * are not repeated here: they are user properties set by `identifyUser`.
 */
export function buildLoginEvent (user: LoggedUser): AnalyticsEvent {
  const properties: LoginProperties = {
    login_method: 'password',
    requires_password_change: !!(user && user.forcePassword)
  }

  return {
    name: LOGIN,
    properties
  }
}
